<template>
    <div class="heading_separator w-2/12"></div>
    <h2> {{data.titulo_principal }}</h2>
</template>
<script>
export default {
    props: ['data'],
}
</script>